// displayDialog系ロゴ画像がブラウザキャッシュ/ServiceWorker/ネットワークのどこから
// 返ってきたかをResource Timing APIで判定し、Whatapへカスタムイベントとして送信する。
export interface ImageCacheStatMeta {
  dialogName: string
  clientId: string
  permissionType: number
}

export function reportImageCacheStat(
  imgEl: HTMLImageElement | null | undefined,
  meta: ImageCacheStatMeta
): void {
  const url = imgEl && (imgEl.currentSrc || imgEl.src)
  if (!url || typeof performance === 'undefined') return

  const entries = performance.getEntriesByName(
    url,
    'resource'
  ) as PerformanceResourceTiming[]
  const entry = entries[entries.length - 1]
  if (!entry) return

  const cacheStatus =
    entry.transferSize !== 0
      ? 'network'
      : entry.workerStart > 0
        ? 'service_worker'
        : 'http_cache'

  const whatap = (window as any).WhatapBrowserAgent
  if (typeof window === 'undefined' || !whatap) return
  whatap.addCustomEvent('rt_image_cache_status', {
    contents: JSON.stringify({ ...meta, cacheStatus })
  })
}
